import React from "react";
import classNames from "classnames";
import { PlusColorIcon } from "@/icons/color-icons";

export type CaCustomButtonProps = {
  btnText: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
};

export function CaCustomButton({ btnText, className, onClick, disabled }: CaCustomButtonProps) {
  return (
    <div
      className={classNames(
        className,
        "ca-font-sans-serif",
        "ca-flex",
        "ca-items-center",
        "ca-text-sm",
        disabled ? "ca-cursor-not-allowed" : "ca-cursor-pointer",
      )}
      onClick={onClick}
      style={{ opacity: disabled ? 0.5 : 1 }}
    >
      <PlusColorIcon className='ca-pr-2.5' />
      <div className='ca-font-semibold' style={{ textDecoration: "underline" }}>
        {btnText}
      </div>
    </div>
  );
}

export default CaCustomButton;
